import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HOME_PATH } from '../../utils/constant';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', padding: '50px 0' }}>
      <Result
        status="404"
        title={<span style={{ color: '#fff' }}>404</span>}
        subTitle={<span style={{ color: '#ccc' }}>Sorry, the page you visited does not exist.</span>}
        extra={
          <Button type="primary" onClick={() => navigate(HOME_PATH)}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
